// A viewport-sized child can still overflow an embedded shell's padded,
// bordered scroll containers. Use their content edges as the actual limit.
export function overviewContentBottom(element) {
  const style=getComputedStyle(element),box=element.getBoundingClientRect();
  return box.bottom-(parseFloat(style.paddingBottom)||0)-(parseFloat(style.borderBottomWidth)||0);
}

export function overviewViewportBottom(element) {
  let bottom=window.innerHeight;
  for(let parent=element.parentElement;parent&&parent!==document.body&&parent!==document.documentElement;parent=parent.parentElement){
    const style=getComputedStyle(parent);
    if(/^(auto|scroll|hidden|clip)$/.test(style.overflowY)||parent.matches('.desktop-main,.desktop-page--embedded,.desktop-section--embedded,.desktop-embedded-page-host,.desktop-embedded-page-host__content')){
      if(parent.getBoundingClientRect().height>0)bottom=Math.min(bottom,overviewContentBottom(parent));
    }
  }
  return bottom;
}
